


import { Component, Vue } from 'vue-property-decorator';
import LoadingAnimationComponent from '@/vue/components/LoadingAnimationComponent.vue';

@Component(
	{
		components:
		{
			LoadingAnimationComponent,
		},
	},
)
export default class MailRequestView extends Vue
{
	private email: string                = '';
	private errorCode: number            = 0;
	private errorMessage: string         = '';
	private isDisabledForSubmit: boolean = false;

	// サブミットボタンクリックイベント
	private onSubmitButtonClicked(event: MouseEvent)
	{
		const target = event.target as HTMLButtonElement;
		const focus  = document.activeElement as HTMLElement;

		// フォーカスが null もしくは BODY オブジェクトの場合(MacOS システムでの動作対策)
		if ( ! focus || focus.tagName === 'BODY' )
		{
			// スルー
			return;
		}
		// 他の要素からのサブミットイベントが発生した場合
		else if (target.type === 'submit'
			&& focus !== target)
		{
			// キャンセル
			event.preventDefault();
			return;
		}
	}

	private async onSubmit()
	{
		// ボタンを押せないようにする
		this.isDisabledForSubmit = true;

		// メールアドレスを API に送信する
		// MEMO: セキュリティ上の観点から失敗してもメール要求完了画面に移行する
		if ( ! await this.sendEmailAddressToAPI(this.email) )
		{
			switch (this.errorCode)
			{
				// リクエストパラメータ関係のエラー
				// MEMO: ブラウザから実行する場合、フロントエンド側で正しい実装をしていれば絶対に通らないはず
				case 2201300:
				case 2201301:
				case 2201302:
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: this.errorCode.toString(),
								msgId: 'param_error',
							},
						},
					);
					return;

				// セッション関係のエラー
				case 2201303:
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: this.errorCode.toString(),
								msgId: 'sid_expired',
							},
						},
					);
					return;

				// サーバー関連のエラー
				case 2200305:
				case 2201304:
				case 2201305:
					this.$router.replace(
						{
							name: 'error',
							query:
							{
								code: this.errorCode.toString(),
								msgId: 'server_error',
							},
						},
					);
					return;
			}
		}

		// 現在の画面をセッションエラー表示に置き換える(ヒストリバック用)
		this.$router.replace(
			{
				name: 'error',
				query: { msgId: 'sid_expired' },
			},
		);
		// メール要求完了画面へ
		this.$router.push({name: 'mail_request_completed'});
	}

	private async sendEmailAddressToAPI(email: string): Promise<boolean>
	{
		let result: boolean = false;
		await this.$http.post(
			this.$store.state.apiPath + 'notify_url',
			{
				email,
			},
		)
		.then( (res) =>
			{
				result = res.data.status ? true : false;
				this.errorCode = res.data.error_code;
			},
		)
		.catch( (err) =>
			{
				// サーバーからのエラーレスポンス
				if ( err.response )
				{
					result = err.response.data.status ? true : false;
					this.errorCode = err.response.data.error_code;
					return;
				}

				// サーバーからのレスポンスがない場合はタイムアウトと見做す
				this.$router.replace(
					{
						name: 'error',
						query:
						{
							code: '2200999',
							msgId: 'timed_out',
						},
					},
				);
			},
		);
		return result;
	}
}
